import loadable from '@loadable/component';

export const OrgDashboardBuyCreditPacksPageLoadable = loadable(
  () => import('./OrgDashboardBuyCreditPacksPage'),
  { resolveComponent: (module) => module.OrgDashboardBuyCreditPacksPage },
);
